<h2 mat-dialog-title>Zaokrąglić wynagrodzenie?</h2>

<div mat-dialog-content>Kwota do wypłaty zawiera grosze. Czy chcesz zaokrąglić w górę do pełnych złotych?</div>

<div mat-dialog-actions align="end">
	<button mat-stroked-button color="primary" (click)="close(false)">Pomiń</button>
	<button mat-flat-button color="primary" (click)="close(true)">Zaokrąglij</button>
</div>
